import {observable} from 'mobx';
import {construct, createInstance, ModelProperties} from 'utils';
import {Language} from './language';
import {SeoApp} from './seo-app';
import {SeoLocaleKey} from './seo-locale-key';

export class SeoLocaleContent {
    @observable id!: number;

    @observable verified: boolean = false;

    @observable outdated: boolean = false;

    @observable contentEdited: string = '';

    @observable contentVerified: string = '';

    @observable appId!: number;

    @observable keyId!: number;

    @observable languageId!: number;

    @observable language?: Language;

    @observable app?: SeoApp;

    @observable key?: SeoLocaleKey;

    constructor(content?: ModelProperties<SeoLocaleContent>) {
        if (content) {
            construct(this, content);
            this.language = createInstance(Language, content.language);
            this.app = createInstance(SeoApp, content.app);
            this.key = createInstance(SeoLocaleKey, content.key);
        }
    }
}